module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "add-lesson__header"
  }, [_c('h2', [_vm._v("Opret klasse")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "add-lesson__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Klassenavn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.klassebetegnelse),
      expression: "klassebetegnelse"
    }],
    ref: "inputTitle",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.klassebetegnelse)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.klassebetegnelse = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__submit"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [_c('button', {
    staticClass: "marg-1-right bg-white",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isFormValid) ? _c('div', {
    staticClass: "hint--top-left",
    attrs: {
      "aria-label": "Udfyld formularen"
    }
  }, [_c('button', {
    staticClass: "submit-button submit-button--disabled"
  }, [_vm._v("Opret")])]) : _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Opret")])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-990cc956!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningCreateKlasseModal.vue
// module id = 2065
// module chunks = 1